/* src/app/components/HeaderTable/styles.js */

export default theme => {
  const { unit } = theme.spacing;
  return {
    root: {
      position: 'relative',
    },
    header: {
      height: unit * 5,
    },
    cell2: {
      width: 50
    },
    cell: {
      // textAlign: 'center',
      // paddingLeft: 0,
      // paddingRight: 0,
      maxWidth: 200,
    },
    alignLeft: {
      textAlign: 'left',
      paddingLeft: unit * 3,
    },
    action: {
      textAlign: 'right',
      paddingRight: unit * 3,
    },
    footer: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      padding: unit,
      position: 'relative',
    },
    pageText: {
      marginLeft: unit * 2,
      marginRight: unit * 2,
    },
    numRecords: {
      position: 'absolute',
      right: unit * 3,
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/components/HeaderTable/styles.js